// The active business's modules and field service set-up state, for anything
// that renders from them — above BusinessProvider (the sidebar) or inside it.
// See businessModulesStore for why this is a store and not a context.

import { useSyncExternalStore } from 'react';
import {
  BusinessModulesState,
  getBusinessModulesState,
  subscribeBusinessModules,
} from '../services/businessModulesStore';

export function useBusinessModules(): BusinessModulesState {
  return useSyncExternalStore(subscribeBusinessModules, getBusinessModulesState);
}
